// @flow
import {registerMiddleware} from '@homeaway/redux-middleware-adapter';

// //
// BEGIN: SERP dependencies
import {VIEWPORT_SIZE_CHANGED} from '../../actions/viewport';
// //
// END: SERP dependencies

import toggleFilterBarDropdownVisiblity from './toggleFilterBarDropdownVisiblity';

export default function registerMiddlewares() {
    registerMiddleware(VIEWPORT_SIZE_CHANGED, toggleFilterBarDropdownVisiblity);
}
